var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8386 10.1039H10.1068M10.1068 10.1039H7.375M10.1068 10.1039V7.37207M10.1068 10.1039V12.8356",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2119 10.106C19.2119 14.3985 19.2119 16.5449 17.8784 17.8784C16.5449 19.2119 14.3985 19.2119 10.106 19.2119C5.81337 19.2119 3.66707 19.2119 2.33354 17.8784C1 16.5449 1 14.3985 1 10.106C1 5.81337 1 3.66707 2.33354 2.33354C3.66707 1 5.81337 1 10.106 1C14.3985 1 16.5449 1 17.8784 2.33354C18.7651 3.22022 19.0622 4.46623 19.1617 6.46358",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.5e9454a3fe380bd940ddf4a7396cc6b1.svg";
export { ForwardRef as ReactComponent };